//Bibliotecas
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
//Componentes Material
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/core';
//Componentes
import LoadingButton from './LoadingButton';

/**
 * Estilos CSS do componente
 */
const styles = (theme) => ({
    vitalizeFab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2)
    }
});

/**
 * Renderiza um botão flutuante
 * @param {Object} props Propriedades do componente
 * @param {Object} props.classes Classes CSS do componente
 * @param {String} props.to Endereço para link
 * @param {*} props.children Corpo do componente
 */
function VitalizeFab({ classes, to, children, ...props }) {
    //Caso possua um link, rederiza o componente necessário
    if (to) {
        return (<Fab component={Link} className={classes.vitalizeFab} {...props} to={to} >{children}</Fab>);
    } else {
        return (
            <LoadingButton component={Fab} className={classes.vitalizeFab} {...props} >
                {children}
            </LoadingButton>
        );
    }
}

VitalizeFab.propTypes = {
    /** Endereço para link */
    to: PropTypes.string,
    /** Classes CSS do componente */
    classes: PropTypes.shape({ 
        vitalizeFab: PropTypes.string 
    })
};

export default withStyles(styles)(VitalizeFab);